import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import Breadcrumb from '../../../components/feature/Breadcrumb';

export default function HeroSection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className="relative min-h-screen w-full flex items-center justify-center overflow-hidden"
      aria-label="Festa Silenciosa — STIB Silent Disco Brasil"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/img/stib/festa-silent-disco.webp"
          alt="Festa Silenciosa Silent Disco — Público com fones LED dançando"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/55 to-black/80" />
      </div>

      {/* Breadcrumb — topo do hero, abaixo do header fixo */}
      <div className="absolute top-24 left-0 right-0 z-20">
        <div className="max-w-6xl mx-auto px-6">
          <Breadcrumb
            variant="light"
            items={[
              { label: 'Home', to: '/' },
              { label: 'Serviços', to: '/servicos' },
              { label: 'Festa Silenciosa' },
            ]}
          />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 text-center">
        <div
          className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <span className="inline-block font-body text-xs font-semibold uppercase tracking-[0.25em] text-primary mb-6 bg-primary/10 border border-primary/30 px-4 py-2 rounded-full">
            Silent Disco Profissional · +300 Festas Realizadas
          </span>
        </div>

        <h1
          className={`font-heading font-extrabold text-5xl md:text-7xl lg:text-8xl text-white leading-tight mb-8 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          Festa Silenciosa<br />
          <span className="text-primary">Silent Disco</span>
        </h1>

        <p
          className={`font-body text-xl md:text-2xl text-white/85 max-w-3xl mx-auto leading-relaxed mb-12 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          Vários DJs simultâneos, fones com LED colorido e zero reclamação de barulho. Sua festa vai até o sol nascer — sem incomodar ninguém.
        </p>

        <div
          className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <Link
            to="/contato"
            className="inline-flex items-center gap-3 bg-primary text-black px-10 py-4 rounded-full font-body font-bold text-base uppercase tracking-wide hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-send-line text-lg" />
            Solicitar Orçamento
          </Link>
          <a
            href="https://wa.me/5511917776227?text=Olá! Quero saber mais sobre a Festa Silenciosa / Silent Disco da STIB."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white/10 border border-white/30 text-white px-10 py-4 rounded-full font-body font-semibold text-base uppercase tracking-wide hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-green-400 text-lg" />
            Falar no WhatsApp
          </a>
        </div>

        {/* Scroll indicator */}
        <div
          className={`mt-20 flex flex-col items-center gap-2 transition-all duration-700 delay-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
        >
          <span className="font-body text-xs text-white/50 uppercase tracking-widest">Conheça mais</span>
          <div className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent animate-pulse" />
        </div>
      </div>
    </section>
  );
}